import {createReducer} from '../../utilities';

import {scope} from '../../../actions/app/tools/tds/listWidget';
import {
  REQUEST_FETCH_TDS,
  SUCCESS_FETCH_TDS,
  FAIL_FETCH_TDS,
  POST_PLAYER_STATE_SUCCESS,
  POST_PLAYER_STATE,
  POST_PLAYER_STATE_ERROR,
  GET_OPTA_STATE,
  GET_OPTA_STATE_SUCCESS,
  GET_OPTA_STATE_ERROR,
  GET_OPTA_PICTURE,
  GET_OPTA_PICTURE_SUCCESS,
  GET_OPTA_PICTURE_ERROR,
} from '../../../actions/entities/tds';

const initialTdsListWidgetState = {
  data: null,
  info: {
    isFetching: false,
    lastAction: null,
    lastPayload: {},
    needRefresh: true,
    updatedAt: null,
    success: false,
    error: false,
    loadingPic: false,
  },
};

function request(state, action) {
  const {type} = action;

  switch (type) {
    case GET_OPTA_PICTURE:
      return {
        ...state,
        info: {
          isFetching: true,
          lastAction: action.type,
          lastPayload: action.payload,
          needRefresh: false,
          updatedAt: null,
          success: false,
          error: false,
          loadingPic: true,
        },
      };

    default:
      return {
        ...state,
        info: {
          isFetching: true,
          lastAction: action.type,
          lastPayload: action.payload,
          needRefresh: false,
          updatedAt: null,
          success: false,
          error: false,
          loadingPic: false,
        },
      };
  }
}

function success(state, action) {
  const {data, payload, receivedAt, type} = action;

  switch (type) {
    case SUCCESS_FETCH_TDS:
      return {
        ...state,
        data,
        info: {
          ...state.info,
          isFetching: false,
          lastPayload: payload,
          needRefresh: false,
          updatedAt: receivedAt,
          success: true,
          error: false,
        },
      };

    case GET_OPTA_PICTURE_SUCCESS:
      return {
        ...state,
        info: {
          ...state.info,
          isFetching: false,
          lastPayload: payload,
          needRefresh: false,
          updatedAt: receivedAt,
          success: true,
          error: false,
          loadingPic: false,
        },
      };

    case POST_PLAYER_STATE_SUCCESS:
      if (state.tds[action.payload.id]) {
        if (action.payload.type === 'injured') {
          if (action.payload.value === 0)
            state.tds[action.payload.id].injured = 0;
          else state.tds[action.payload.id].injured = 1;
        }
        if (action.payload.type === 'suspended') {
          if (action.payload.value === 0)
            state.tds[action.payload.id].suspended = 0;
          else state.tds[action.payload.id].suspended = 1;
        }
        if (action.payload.type === 'pending') {
          if (action.payload.value === 0)
            state.tds[action.payload.id].pending = 0;
          else state.tds[action.payload.id].pending = 1;
        }
        if (action.payload.type === 'reported') {
          if (action.payload.value === 0)
            state.tds[action.payload.id].reported = 0;
          else state.tds[action.payload.id].reported = 1;
        }
      } else
        state.tds[action.payload.id] = {
          [action.payload.type]: action.payload.value,
        };
      return {
        ...state,
        info: {
          ...state.info,
          isFetching: false,
          lastPayload: payload,
          needRefresh: false,
          updatedAt: receivedAt,
          success: true,
          error: false,
        },
      };

    default:
      return {
        ...state,
        info: {
          ...state.info,
          isFetching: false,
          lastPayload: payload,
          needRefresh: false,
          updatedAt: receivedAt,
          success: true,
          error: false,
        },
      };
  }
}

function fail(state, action) {
  const {error, payload, type} = action;
  switch (type) {
    case POST_PLAYER_STATE_ERROR:
      if (state.tds[action.payload.id]) {
        if (action.payload.type === 'injured') {
          if (action.payload.value === 0)
            state.tds[action.payload.id].injured = 0;
          else state.tds[action.payload.id].injured = 1;
        }
        if (action.payload.type === 'suspended') {
          if (action.payload.value === 0)
            state.tds[action.payload.id].suspended = 0;
          else state.tds[action.payload.id].suspended = 1;
        }
        if (action.payload.type === 'pending') {
          if (action.payload.value === 0)
            state.tds[action.payload.id].pending = 0;
          else state.tds[action.payload.id].pending = 1;
        }
        if (action.payload.type === 'reported') {
          if (action.payload.value === 0)
            state.tds[action.payload.id].reported = 0;
          else state.tds[action.payload.id].reported = 1;
        }
      } else
        state.tds[action.payload.id] = {
          [action.payload.type]: action.payload.value,
        };
      return {...state};

    default:
      return {
        ...state,
        info: {
          ...state.info,
          isFetching: false,
          lastPayload: payload,
          needRefresh: false,
          success: false,
          error,
        },
      };
  }
}

export default createReducer(
  initialTdsListWidgetState,
  {
    [REQUEST_FETCH_TDS]: request,
    [POST_PLAYER_STATE]: request,
    [GET_OPTA_STATE]: request,
    [GET_OPTA_PICTURE]: request,
    [SUCCESS_FETCH_TDS]: success,
    [POST_PLAYER_STATE_SUCCESS]: success,
    [GET_OPTA_STATE_SUCCESS]: success,
    [GET_OPTA_PICTURE_SUCCESS]: success,
    [FAIL_FETCH_TDS]: fail,
    [POST_PLAYER_STATE_ERROR]: fail,
    [GET_OPTA_STATE_ERROR]: fail,
    [GET_OPTA_PICTURE_ERROR]: fail,
  },
  scope,
);



// WEBPACK FOOTER //
// ./src/reducers/app/tools/tds.js